import type {
  AgentReasoningConfig,
  ReasoningEffort,
} from '@/types/agent.types';

export interface ReasoningToggleState {
  enabled: boolean;
}

/** Effort sent when the per-turn toggle is ON and the agent set no override. */
export const DEFAULT_REASONING_ON_EFFORT: ReasoningEffort = 'high';

/**
 * Resolve the reasoning effort to send this turn. Returns `null` when the
 * parameter should be omitted entirely — callers treat null as "send no
 * reasoning_effort and let the model use its server-side default".
 *
 * Null is returned when the agent is not reasoning-capable OR the toggle is
 * OFF. When capable and ON, returns the agent's configured `onEffort`
 * (default 'high'). Provider-neutral: the caller maps this to the
 * provider-specific request parameter (e.g. Azure's `reasoning_effort`).
 */
export function buildEffectiveReasoningEffort(
  reasoningConfig: AgentReasoningConfig | undefined,
  toggle: ReasoningToggleState
): ReasoningEffort | null {
  if (!reasoningConfig?.supportsReasoning) return null;
  if (!toggle.enabled) return null;
  return reasoningConfig.onEffort ?? DEFAULT_REASONING_ON_EFFORT;
}
